import { useAnnouncements } from '@/hooks/useAnnouncements';

/** Replaces the ToastController usage in AnnouncementService. */
export function AnnouncementToasts() {
  const { unacknowledged, acknowledge } = useAnnouncements();
  if (unacknowledged.length === 0) return null;

  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex flex-col items-center gap-2 p-4"
    >
      {unacknowledged.map((announcement) => (
        <div
          key={announcement.announcementId}
          className="pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-lg bg-slate-900 px-4 py-3 text-sm text-white shadow-lg"
        >
          <p className="flex-1">{announcement.message}</p>
          <button
            type="button"
            onClick={() => acknowledge(announcement.announcementId)}
            className="shrink-0 rounded px-2 py-1 font-medium text-tertiary hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
